import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'

import * as styles from './RentalPortalApplicantsBoardColumnEmpty.module.css'

function RentalPortalApplicantsBoardColumnEmpty() {
  const { t } = useTranslation()

  return (
    <Text isSecondary className={styles.RentalPortalApplicantsBoardColumnEmpty}>
      {t('RentalPortal.ListingBoardEmptyColumnKey')}
    </Text>
  )
}

export default RentalPortalApplicantsBoardColumnEmpty
